import * as yup from 'yup';
import yupLocale from './yupLocale';
import {
    testAwbEmail,
    testCustomerNumber,
    testDateNotInFuture,
    testExtendedRequired,
    testIban,
    testLandlineAreaCode,
    testMaxAge,
    testMinAge,
    testMobileAreaCode,
    testNotStartsWith,
    testNumeric,
    testOptionalMin,
    testOptionalOneOfNumber,
    testOptionalOneOfString,
    testStartsWith,
    testSwitchingDate,
    testUniqueCli,
    testUnknownCustomerNumber,
    testValidDate,
    testZip,
} from './yupMethods';

yup.setLocale(yupLocale);
yup.addMethod(yup.string, 'numeric', testNumeric);
yup.addMethod(yup.string, 'optionalMin', testOptionalMin);
yup.addMethod(yup.string, 'optionalOneOf', testOptionalOneOfString);
yup.addMethod(yup.number, 'optionalOneOf', testOptionalOneOfNumber);
yup.addMethod(yup.string, 'startsWith', testStartsWith);
yup.addMethod(yup.string, 'notStartsWith', testNotStartsWith);
yup.addMethod(yup.string, 'validDate', testValidDate);
yup.addMethod(yup.string, 'notInFuture', testDateNotInFuture);
yup.addMethod(yup.string, 'minAge', testMinAge);
yup.addMethod(yup.string, 'maxAge', testMaxAge);
yup.addMethod(yup.string, 'switchingDate', testSwitchingDate);
yup.addMethod(yup.string, 'zip', testZip);
yup.addMethod(yup.string, 'mobileAreaCode', testMobileAreaCode);
yup.addMethod(yup.string, 'landlineAreaCode', testLandlineAreaCode);
yup.addMethod(yup.string, 'customerNumber', testCustomerNumber);
yup.addMethod(yup.string, 'unknownCustomerNumber', testUnknownCustomerNumber);
yup.addMethod(yup.string, 'iban', testIban);
yup.addMethod(yup.string, 'awbEmail', testAwbEmail);
yup.addMethod(yup.object, 'uniqueCli', testUniqueCli);
yup.addMethod(yup.string, 'extendedRequired', testExtendedRequired);
yup.addMethod(yup.number, 'extendedRequired', testExtendedRequired);

declare module 'yup' {
    interface ObjectSchema<TShape, TContext, TIn, TOut> {
        uniqueCli(message?: string): ObjectSchema<TShape, TContext, TIn, TOut>;
    }

    interface NumberSchema {
        optionalOneOf(values: number[], message?: string): NumberSchema;

        extendedRequired(excludedValue: number, message?: string): NumberSchema;
    }

    interface StringSchema {
        optionalOneOf(values: string[], message?: string): StringSchema;

        numeric(options?: { message?: string; excludeEmptyString?: boolean }): StringSchema;

        optionalMin(min: number, message?: string): StringSchema;

        validDate(options?: { message?: string; excludeEmptyString?: boolean }): StringSchema;

        notInFuture(options?: { message?: string; excludeEmptyString?: boolean }): StringSchema;

        minAge(age: number, options?: { message?: string; excludeEmptyString?: boolean }): StringSchema;

        maxAge(age: number, options?: { message?: string; excludeEmptyString?: boolean }): StringSchema;

        switchingDate(options?: { message?: string; excludeEmptyString?: boolean }): StringSchema;

        zip(options?: { message?: string; excludeEmptyString?: boolean }): StringSchema;

        awbEmail(options?: { message?: string; excludeEmptyString?: boolean }): StringSchema;

        mobileAreaCode(options?: { message?: string; excludeEmptyString?: boolean }): StringSchema;

        landlineAreaCode(options?: { message?: string; excludeEmptyString?: boolean }): StringSchema;

        customerNumber(options?: { message?: string; excludeEmptyString?: boolean }): StringSchema;

        unknownCustomerNumber(options?: { message?: string; excludeEmptyString?: boolean }): StringSchema;

        iban(options?: { message?: string; excludeEmptyString?: boolean }): StringSchema;

        startsWith(prefix: string, options?: { message?: string; excludeEmptyString?: boolean }): StringSchema;
        notStartsWith(prefix: string, options?: { message?: string; excludeEmptyString?: boolean }): StringSchema;

        germanIban(options?: { excludeEmptyString?: boolean }): StringSchema;

        extendedRequired(excludedValue: string, message?: string): StringSchema;
    }
}

export default yup;
